import Registo from './Registo'

export default Registo